module.exports = __webpack_public_path__ + "img/share_bottom_text@3x.png";